export default "__VITE_ASSET__BZxpapby__"